<template>
  <div class="wrapper">
    <a href="#" class="ctaLink" @click.prevent="showOutro('signup')">Pledge to vote</a>
    <a href="#" class="socialLink" @click.prevent="showOutro('share')">
      <span class="icon"></span> Share <span v-show="!isMobile">your</span> districts
    </a>
  </div>
</template>

<script>
  export default {
    name: 'ShareLinks',
    props: ['isMobile', 'showOutro']
  }
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

a {
  text-decoration: none;
}
.wrapper {
  background: $secondaryAccentColor;
  font-size: 1.125rem;
  line-height: 1.5;
  font-weight: bold;
  box-sizing: border-box;
  height: 45px;
  box-shadow: $boxShadow;
}
.socialLink {
  background: #fff;
  color: $darkTextColor;
  padding: 0.5em 1em;
  float: right;
  box-sizing: border-box;
  height: 100%;
  white-space: nowrap;
}
.ctaLink {
  @extend .socialLink;
  background: $secondaryAccentColor;
  color: #fff;
  float: left;
}
.icon {
  background-image: url('../assets/icons/icon-share-3b3532.svg');
  width: 22px;
  height: 19px;
  margin: -3px 5px 0 -3px;
}

/* Mobile view */
.mq-mobile {
  .socialLink,
  .ctaLink {
    width: 50%;
    text-align: center;
  }
  .socialLink {
    padding: 0.5em 0.75em;
  }
  .icon {
    margin: 0;
  }
}
/* Only teh very smallest screens ~ iPhone 5 */
@media (max-width: 370px) {
  .wrapper {
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareLinks.vue